import { DEAL_ACTIVITY } from './dealActivityEvent';
import { CALENDAR_ACCOUNT_OPTIONS } from './calendarAccountOptions';
import { CALENDAR_CONTACT_OPTIONS } from './calendarContactOptions';
import { DEAL_ACTIVITY_EVENTS_LISTING } from './dealActivityEventsListing';

import { RE_DATE_EVENT_ACTIVITIES } from './reDateEventActivities';
import { COMPLETE_EVENT_ACTIVITIES } from './completeEventActivities';
import { MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES } from './moveToTomorrowDateEventActivities';

export * from './types';
export * from './usaCalendar';
export * from './useCalendarFormOptions';

export const calendarApi = {
  dealActivityEventsListing: DEAL_ACTIVITY_EVENTS_LISTING,
  dealActivity: DEAL_ACTIVITY,

  calendarAccountOptions: CALENDAR_ACCOUNT_OPTIONS,
  calendarContactOptions: CALENDAR_CONTACT_OPTIONS,

  reDate: RE_DATE_EVENT_ACTIVITIES,
  complete: COMPLETE_EVENT_ACTIVITIES,
  moveToTomorrow: MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES,
};
